module.exports = __webpack_public_path__ + "img/user-created.cee0b658.svg";